import {InputProps} from "app/Interface/Component/FormInput"
import cls from "classnames"
import React, {ChangeEvent, useEffect, useRef} from "react"
import {InputGroup} from "react-bootstrap"

function InputTextController<T>(
  {
    id,
    type,
    value,
    onChange,

    focus,
    focusToggle,

    placeholder,
    autoComplete,

    disabled,

    preText
  }: InputProps<T>) {

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (focus)
      inputRef.current?.focus()
  }, [inputRef, focus, focusToggle])

  function changeHandler(e: ChangeEvent<any>) {
    onChange((e.target.value).trimStart())
  }

  function input() {
    return (
      <input
        id={`${type}-${id}`}
        name={id}
        ref={inputRef}
        type={type}
        //@ts-ignore overwrite default react value and control trough T`
        value={value ?? ''} // Add '' to not change from un-controlled to controlled if undefined is provided
        onChange={changeHandler}
        className={cls('form-control', id)}
        placeholder={placeholder}
        autoComplete={autoComplete ? 'on' : 'off'}
        disabled={disabled ?? false}
      />
    )
  }

  // Todo - Make a wrapper so <input/> is not doubled
  return preText ? (
    <InputGroup>
      <span className={`input-group-text`}>{preText}</span>
      {input()}
    </InputGroup>
  ) : input()
}

export default InputTextController
